import { render, staticRenderFns } from "./_dealer.vue?vue&type=template&id=774a4c16&"
import script from "./_dealer.vue?vue&type=script&lang=js&"
export * from "./_dealer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports